export const TRANSLATIONS_EN_HOME_PULSE_AND_CALENDAR = {
  "home.pulse.eyebrow": "Live classification engine",
  "home.pulse.subtitle": "We monitor how Innovadoc AI is labeling your documents right now.",
  "home.pulse.originNote": "Every other signal on this home—dates, priorities and actions—comes from this classification stream.",
  "home.pulse.state.ok": "All clear",
  "home.pulse.state.processing": "Attention needed",
  "home.pulse.state.attention": "Critical",
  "home.pulse.summary.documents": "Documents already understood",
  "home.pulse.summary.artifacts": "Artifact types mapped",
  "home.pulse.summary.categories": "Categories recognized",
  "home.pulse.summary.overdue": "Overdue",
  "home.pulse.summary.upcoming": "Upcoming",
  "home.pulse.modal.eyebrow": "Key dates",
  "home.pulse.modal.overdueTitle": "Overdue documents",
  "home.pulse.modal.upcomingTitle": "Upcoming documents",
  "home.pulse.modal.countLabel": "Showing",
  "home.pulse.modal.ofLabel": "of",
  "home.pulse.modal.dueLabelOverdue": "Overdue since",
  "home.pulse.modal.dueLabelUpcoming": "Due",
  "home.pulse.modal.roleLabel": "Role",
  "home.pulse.modal.stateLabel": "Status",
  "home.pulse.modal.actionLabel": "Action",
  "home.pulse.modal.close": "Close",
  "home.pulse.modal.viewDocument": "View document",
  "home.pulse.modal.openQueue": "View priority items",
  "home.pulse.modal.overdueEmpty": "No overdue documents.",
  "home.pulse.modal.upcomingEmpty": "No upcoming documents.",
  "home.pulse.modal.limitedHint": "This is a short list. View your priority items to see everything.",
  "home.pulse.artifactTypes.title": "Detected artifact types",
  "home.pulse.artifactTypes.showMore": "Show more",
  "home.pulse.artifactTypes.showLess": "Show less",
  "home.pulse.recentClassifications.title": "Recent classifications",
  "home.pulse.recentClassifications.countLabel": "entries",
  "home.pulse.recentClassifications.empty": "No classifications in the last hour.",
  "home.pulse.empty": "No pulse data available yet.",
  "home.datesSummary.eyebrow": "Important dates",
  "home.datesSummary.title": "Important dates in your documents",
  "home.datesSummary.totalLabel": "documents with upcoming dates",
  "home.datesSummary.description": "Upcoming renewals and deadlines worth keeping an eye on.",
  "home.datesSummary.connection": "Sorted by what's due first.",
  "home.datesSummary.roleLabel": "Owner",
  "home.datesSummary.role.renewal": "Renewals",
  "home.datesSummary.role.audit": "Audits",
  "home.datesSummary.role.expiration": "Expirations",
  "home.datesSummary.role.compliance": "Compliance",
  "home.datesSummary.tooltip": "Automatically detected in your documents.",
  "home.datesSummary.clearFilter": "Clear role filter",
  "home.datesSummary.panelEyebrow": "Important dates",
  "home.datesSummary.panelTitle": "Important dates in your documents",
  "home.datesSummary.panelSubtitle": "Documents and their upcoming dates worth reviewing.",
  "home.datesSummary.closePanel": "Close dates panel",
  "home.datesSummary.panelQueueCta": "View these documents",
  "home.datesSummary.panelFilterActive": "Filter active: showing just this role.",
  "home.datesSummary.panelEmpty": "No detected dates to display.",
  "home.datesSummary.empty": "No dates detected yet.",
  "home.datesSummary.filterSaved": "Preference saved.",
  "home.datesSummary.state.active": "Active",
  "home.datesSummary.state.upcoming": "Upcoming",
  "home.datesSummary.state.resolved": "Resolved",
  "home.datesSummary.previewTitle": "Upcoming dates",
  "home.datesSummary.previewSubtitle": "by due date",
  "home.datesSummary.previewAction": "View list",
  "home.datesSummary.previewChangeRole": "Change owner",
  "home.datesSummary.previewOpenCalendar": "Open calendar",
  "home.stats.title": "How the system understands your documents today",
  "home.stats.description": "We track these metrics to make sure classification stays healthy.",
  "home.stats.note": "They back every recommendation and priority list you see above.",
  "home.stats.label.pending_documents": "Pending documents",
  "home.stats.label.evaluated_documents": "Evaluated documents",
  "home.stats.label.oldest_pending_age_seconds": "Oldest pending age (seconds)",
  "home.stats.label.last_evaluation_age_seconds": "Last evaluation age (seconds)",
  "home.stats.label.evaluation_duration_p95_ms": "Evaluation duration p95 (ms)",
  "home.stats.label.evaluation_duration_p99_ms": "Evaluation duration p99 (ms)",
  "home.stats.label.ranker_duration_p95_ms": "Ranker duration p95 (ms)",
  "home.stats.label.ranker_duration_p99_ms": "Ranker duration p99 (ms)",
  "home.stats.label.error_rate": "Error rate",
  "home.stats.label.throughput_eval_per_hour": "Throughput eval / hour",
  "home.stats.label.throughput_rank_per_hour": "Throughput rank / hour",
  "home.stats.empty": "No metrics available yet.",
  "home.decisionPulse.eyebrow": "Operational pulse",
  "home.decisionPulse.headline.alert": "Some decisions need immediate attention",
  "home.decisionPulse.headline.watch": "The workload is stable, but there are near-term moves to make",
  "home.decisionPulse.headline.calm": "Everything is under control for now",
  "home.decisionPulse.copy.actNow": "need immediate action",
  "home.decisionPulse.copy.overdue": "are overdue",
  "home.decisionPulse.copy.actSoon": "should be resolved soon",
  "home.decisionPulse.copy.monitoring": "decisions remain under monitoring",
  "home.decisionPulse.copy.empty": "There are no active decisions right now.",
  "home.decisionPulse.connection.label": "SSE",
  "home.decisionPulse.connection.connecting": "Connecting",
  "home.decisionPulse.connection.connected": "Real-time",
  "home.decisionPulse.connection.disconnected": "Disconnected",
  "home.decisionPulse.connection.error": "Lagging",
  "home.knowledgeExpirations.title": "Upcoming document expirations",
  "home.knowledgeExpirations.viewAll": "View all",
  "home.knowledgeExpirations.empty": "No upcoming expirations in your documents.",
  "home.knowledgeExpirations.errorTitle": "Could not load expirations",
  "home.knowledgeExpirations.errorMessage": "Please try again in a few seconds.",
  "home.knowledgeEntities.title": "Entities with recent activity",
  "home.knowledgeEntities.viewAll": "Explore",
  "home.knowledgeEntities.sources": "sources",
  "home.knowledgeEntities.empty": "No entities with recent activity yet.",
  "home.knowledgeEntities.errorTitle": "Could not load entities",
  "home.knowledgeEntities.errorMessage": "Please try again in a few seconds.",
  "home.calendar.eyebrow": "Calendar",
  "home.calendar.title": "Decision calendar",
  "home.calendar.description": "Browse decisions by due date and keep the existing detail workspace on the side.",
  "home.calendar.empty": "There are no dated decisions for this range.",
  "home.calendar.emptyMonth": "No dated decisions",
  "home.calendar.undated": "Undated decisions",
  "home.calendar.today": "Today",
  "home.calendar.previous": "Previous",
  "home.calendar.next": "Next",
  "home.calendar.moreEntries": "more",
  "home.calendar.emptyDay": "No tracked events on this day.",
  "home.calendar.granularity.week": "Week",
  "home.calendar.granularity.month": "Month",
  "home.calendar.granularity.year": "Year",
  "home.calendar.agenda.empty": "No decisions scheduled this month.",
  "home.calendar.agenda.today": "Today",
  "home.calendar.agenda.todayBadge": "Today",
  "home.calendar.agenda.previousMonth": "Previous month",
  "home.calendar.agenda.nextMonth": "Next month",
  "home.viewMode.label": "View mode",
};
